import { tns } from "tiny-slider";

export default class ImageSlider {
    getCarouselOptions(item) {
        return {
            autoplay: false,
            axis: "horizontal",
            container: item,
            controls: true,
            controlsContainer: "#imageControls",
            prevButton: ".image-previous",
            nextButton: ".image-next",
            items: 1,
            slideBy: 1,
            nav: true,
            loop: true,
            gutter: 40,
            speed: 500,
            mouseDrag: false,
            autoplayButton: false,
            autoplayButtonOutput: false,
            touch: false,
            center: true,
            responsive: {
                768: {
                    center: false,
                    gutter: 100,
                },
                992: {
                    slideBy: 2,
                    items: 2,
                    gutter: 60,
                },
                1200: {
                    gutter: 60,
                },
                1680: {
                    gutter: 120,
                },
            },
        };
    }

    beforeAfter(slider) {
        const imageWrappers = slider.querySelectorAll('.card-image__wrapper');

        if (imageWrappers) {
            imageWrappers.forEach((wrapper) => {
                const _scroller = wrapper.querySelector('.scroller');
                const _after = wrapper.querySelector('.after');

                let active = false;

                _scroller.addEventListener('mousedown', function () {
                    active = true;
                    _scroller.classList.add('scrolling');
                });

                document.body.addEventListener('mouseup', function () {
                    active = false;
                    _scroller.classList.remove('scrolling');
                });

                document.body.addEventListener('mouseleave', function () {
                    active = false;
                    _scroller.classList.remove('scrolling');
                });

                document.body.addEventListener('mousemove', function (e) {
                    if (!active) return;
                    let x = e.pageX;
                    x -= wrapper.getBoundingClientRect().left;
                    scrollIt(x, wrapper);
                });

                function scrollIt(x, wrapper) {
                    let transform = Math.max(0, Math.min(x, wrapper.offsetWidth));
                    _after.style.width = transform + "px";
                    _scroller.style.left = transform - 25 + "px";
                }

                scrollIt('150%', wrapper);

                document.body.addEventListener('touchmove', function (e) {
                    if (!active) return;
                    let x = e.changedTouches[0].pageX;
                    x -= wrapper.getBoundingClientRect().left;
                    scrollIt(x, wrapper);
                });

                _scroller.addEventListener('touchstart', function () {
                    active = true;
                    _scroller.classList.add('scrolling');
                });

                document.body.addEventListener('touchend', function () {
                    active = false;
                    _scroller.classList.remove('scrolling');
                });

                document.body.addEventListener('touchcancel', function () {
                    active = false;
                    _scroller.classList.remove('scrolling');
                });
            });
        }
    }

    triggerCarousel() {
        const blocks = document.querySelectorAll(".image-slider");
        if (blocks.length) {
            [...blocks].forEach((block) => {
                const slidesNum = block.querySelectorAll('.card-image').length;
                if (slidesNum > 1) {
                    const slider = block.querySelector(".image-wrapper--slider");
                    if (slider) {
                        let options = this.getCarouselOptions(slider);
                        tns(options);
                        this.beforeAfter(slider);
                    }
                }
            });
        }
    }

    beforeAfterGallery() {
        const imageGallery = document.querySelector('.image-wrapper--gallery');
        if (imageGallery) {
            this.beforeAfter(imageGallery);
        }
    }

    init() {
        this.triggerCarousel();
        this.beforeAfterGallery();
    }
}
